<template>
  <el-form
    label-position="top"
    :model="form"
    class="text-left"
    :rules="rules"
    ref="form"
  >
    <el-row :gutter="30">
      <el-col :span="9" :sm="4" class="pd-r-less">
        <el-form-item label="คำนำหน้าชื่อ" prop="prefix">
          <el-select
            v-model="form.prefix"
            placeholder="คำนำหน้าชื่อ"
            style="width: 100%;"
          >
            <el-option
              v-for="item in prefixList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="15" :sm="8">
        <el-form-item label="ชื่อภาษาไทย" prop="nameTh">
          <el-input v-model="form.nameTh"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="นามสกุลภาษาไทย" prop="lastNameTh">
          <el-input v-model="form.lastNameTh"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="ชื่อภาษาอังกฤษ" prop="nameEn">
          <el-input v-model="form.nameEn"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="นามสกุลภาษาอังกฤษ" prop="lastNameEn">
          <el-input v-model="form.lastNameEn"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="หมายเลขโทรศัพท์" prop="phoneNumber">
          <VuePhoneNumberInput
            v-model="form.phoneNumber"
            @update="updatePhoneNumber"
            :default-country-code="phoneNumber.countryCode"
            color="#353535"
            error-color="#C81800"
            valid-color="#00C88C"
            :error="!phoneNumber.numberValid"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="30">
      <el-col :span="24" :sm="12">
        <el-form-item label="ตำแหน่งงาน" prop="position">
          <el-input v-model="form.position"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="ชื่อหน่วยงาน/องค์กร/บริษัท">
          <el-input v-model="form.organization"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="ที่อยู่" prop="address">
          <el-input v-model="form.address"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12" class="pd-b-5">
        <el-form-item label="รหัสไปรษณีย์" prop="postcode">
          <ThailandAutoComplete
            v-model="form.postcode"
            type="zipcode"
            @select="selectAddress"
            @input="checkValid('postcode')"
            color="#409EFF"
            class="form-input"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12" class="pd-b-5">
        <el-form-item label="ตำบล/แขวง" prop="subDistrict">
          <ThailandAutoComplete
            v-model="form.subDistrict"
            type="district"
            @select="selectAddress"
            @input="checkValid('subDistrict')"
            color="#409EFF"
            class="form-input"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12" class="pd-b-5">
        <el-form-item label="อำเภอ/เขต" prop="district">
          <ThailandAutoComplete
            v-model="form.district"
            type="amphoe"
            @select="selectAddress"
            @input="checkValid('district')"
            color="#409EFF"
            class="form-input"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12" class="pd-b-5">
        <el-form-item label="จังหวัด" prop="province">
          <ThailandAutoComplete
            v-model="form.province"
            type="province"
            @select="selectAddress"
            @input="checkValid('province')"
            color="#409EFF"
            class="form-input"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="30">
      <el-col :span="24" :sm="12">
        <el-form-item label="อีเมล" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row  :gutter="30">
      <el-col :span="24" :sm="12">
        <el-form-item label="รหัสผ่าน" prop="password">
          <el-input v-model="form.password" :type="hidePass?'password':''" autocomplete="off">
              <span slot="suffix">
                <i v-if="hidePass" @click="hidePass = false" class="cursor-pointer fas fa-eye mg-r-5"></i>
                <i v-else @click="hidePass = true" class="cursor-pointer fas fa-eye-slash mg-r-5"></i>
              </span>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="ยืนยันรหัสผ่าน" prop="confirmPassword">
           <el-input
            v-model="form.confirmPassword"
            :type="hideConfirmPass?'password':''"
            autocomplete="off"
          >
            <span slot="suffix">
              <i v-if="hideConfirmPass" @click="hideConfirmPass = false" class="cursor-pointer fas fa-eye mg-r-5"></i>
              <i v-else @click="hideConfirmPass = true" class="cursor-pointer fas fa-eye-slash mg-r-5"></i>
            </span>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="text-center pd-y-3">
      <el-button
        v-if="type == 'add'"
        @click="createInstructor"
        type="primary"
        round
        class="pd-x-1"
        >เพิ่มผู้สอน</el-button
      >
      <el-button
        v-if="type == 'update'"
        @click="updateInstructor"
        type="primary"
        round
        class="pd-x-1"
        >บันทึก</el-button
      >
    </div>
  </el-form>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import ThailandAutoComplete from "vue-thailand-address-autocomplete";

export default {
  components: {
    VuePhoneNumberInput,
    ThailandAutoComplete,
  },
  props: {
    type: {
      type: String,
      default() {
        return "add";
      },
    },
    instructor: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  computed: {
    prefixList() {
      return this.$store.state.prefixList;
    },
  },
  data() {
    var validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error("รหัสผ่านไม่ตรงกัน"));
      } else {
        callback();
      }
    };
    var validatePhoneNumber = (rule, value, callback) => {
      if (!this.phoneNumber.numberValid) {
        callback(new Error("กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง"));
      } else {
        callback();
      }
    };
    var validateThai = (rule, value, callback) => {
      let regx = /^[^a-z^A-Z]+$/i;
      if (!regx.test(value)) {
        callback(new Error("กรุณากรอกตัวอักษรภาษาไทย"));
      } else {
        callback();
      }
    };
    var validateEng = (rule, value, callback) => {
      let regx = /^[^ก-๛]+$/i;
      if (!regx.test(value)) {
        callback(new Error("กรุณากรอกตัวอักษรภาษาอังกฤษ"));
      } else {
        callback();
      }
    };
    return {
      hidePass:true,
      hideConfirmPass:true,
      form: {
        prefix: "",
        nameTh: "",
        lastNameTh: "",
        nameEn: "",
        lastNameEn: "",
        phoneNumber: "",
        position: "",
        organization: "",
        address: "",
        postcode: "",
        subDistrict: "",
        district: "",
        province: "",
        email: "",
        password: "",
        confirmPassword: "",
      },
      rules: {
        prefix: [
          {
            required: true,
            message: "กรุณาเลือกคำนำหน้าชื่อ",
            trigger: ["blur", "change"],
          },
        ],
        nameTh: [
          { required: true, message: "กรุณากรอกชื่อภาษาไทย", trigger: "blur" },
          { validator: validateThai, trigger: "blur" },
        ],
        lastNameTh: [
          {
            required: true,
            message: "กรุณากรอกนามสกุลภาษาไทย",
            trigger: "blur",
          },
          { validator: validateThai, trigger: "blur" },
        ],
        nameEn: [
          {
            required: true,
            message: "กรุณากรอกชื่อภาษาอังกฤษ",
            trigger: "blur",
          },
          { validator: validateEng, trigger: "blur" },
        ],
        lastNameEn: [
          {
            required: true,
            message: "กรุณากรอกนามสกุลภาษาอังกฤษ",
            trigger: "blur",
          },
          { validator: validateEng, trigger: "blur" },
        ],
        phoneNumber: [{ validator: validatePhoneNumber, trigger: "blur" }],
        postcode: [
          {
            min: 5,
            max: 5,
            message: "กรุณากรอกรหัสไปรษณีย์ให้ถูกต้อง",
            trigger: ["blur", "change"],
          },
        ],
        email: [
          {
            required: true,
            message: "กรุณากรอกอีเมล",
            trigger: "blur",
          },
          {
            type: "email",
            message: "กรุณากรอกอีเมลให้ถูกต้อง",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "กรุณากรอกรหัสผ่าน", trigger: "blur" },
          {
            min: 8,
            message: "กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวขึ้นไป",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: "กรุณากรอกยืนยันรหัสผ่าน",
            trigger: "blur",
          },
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
      },
      phoneNumber: {
        countryCode: "TH",
        formatNational: "",
        numberValid: true,
      },
    };
  },
  watch: {
    instructor() {
      this.setInstructor();
    },
  },
  created() {
    if (this.type == 'update') {
      let password = this.rules.password.slice(1,this.rules.password.length)
      let confirmPassword = this.rules.confirmPassword.slice(1,this.rules.password.length)

      this.rules.password = password
      this.rules.confirmPassword = confirmPassword
    }
  },
  mounted() {
    this.setInstructor();
  },
  methods: {
    setInstructor() {

      if (this.instructor != null) {
        this.form = {
          prefix: this.instructor.titleName,
          nameTh: this.instructor.nameTH,
          lastNameTh: this.instructor.surnameTH,
          nameEn: this.instructor.nameEN,
          lastNameEn: this.instructor.surnameEN,
          phoneNumber: this.instructor.mobilephone,
          position: this.instructor.position,
          organization: this.instructor.institution.name,
          address: this.instructor.institution.address,
          postcode: this.instructor.institution.postcode,
          subDistrict: this.instructor.institution.subdistrict,
          district: this.instructor.institution.district,
          province: this.instructor.institution.province,
          email: this.instructor.email,
          password: '',
          confirmPassword: '',
        };

        this.phoneNumber.countryCode = this.instructor.countryCode;
      }
    },
    createInstructor() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.form));
          obj["countryCode"] = this.phoneNumber.countryCode;
          this.$emit("createInstructor", obj);
        }
      });
    },
    updateInstructor() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.form));
          obj["countryCode"] = this.phoneNumber.countryCode;
          this.$emit("updateInstructor", obj);
        }
      });
    },
    updatePhoneNumber(payload) {
      this.form.phoneNumber = payload
        ? payload.phoneNumber.replace(/[\s (]/g, "")
        : "";
      this.phoneNumber.countryCode = payload.countryCode;
      this.phoneNumber.formatNational = payload.formatNational;
      this.phoneNumber.numberValid = payload.isValid;
    },
    selectAddress(address) {
      this.form.postcode = address.zipcode;
      this.form.subDistrict = address.district;
      this.form.district = address.amphoe;
      this.form.province = address.province;
    },
    checkValid(field) {
      this.$refs["form"].validateField(field);
    },
  },
};
</script>

<style scoped>
.input-time-learn {
  width: 130px;
}

.image-preview-course {
  width: 370px;
  height: 200px;

  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  border-radius: 5px;
  position: relative;
}
.icon-preview-image {
  position: absolute;
  right: -4px;
  top: -4px;
  color: #c4c4c4;
  cursor: pointer;
  background: #fff;
  border-radius: 20px;
}
.show-preview {
  height: 230px;
}
</style>
